import type React from "react";
import {Tooltip} from "@mui/material";

const LINK_NOTE = "Linkage's confidence in this link; at 0.5 or more it may own the transaction";

/**
 * A model's confidence, 0 to 1, on the design's one score ramp: high from
 * 0.8, medium from 0.5 (the threshold a link may own its transaction at), low
 * below. It is the model's own number; `title` says whose, linkage's by default.
 */
export const ConfidenceBadge: React.FC<{value: number; title?: string}> = ({value, title = LINK_NOTE}) => {
    const tier = value >= 0.8 ? 'high' : value >= 0.5 ? 'med' : 'low';
    return (
        <Tooltip arrow title={title}>
            <span className={`ci-score ci-score--${tier}`}>{Math.round(value * 100)}</span>
        </Tooltip>
    );
};
